/* import __COLOCATED_TEMPLATE__ from './entity-type.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { LegalEntitiesBusinessEntityType, NonIndividualLegalEntitiesBusinessEntityType } from '@banking/api/utils/business-types';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
const DUMMY_TINS = new Set(['000000000', '111111111', '222222222', '333333333', '444444444', '555555555', '666666666', '777777777', '888888888', '999999999', '012345678', '123456789', '987654321', '000000001', '111223333', '123121234', '123123123', '123451234']);
let EntityType = (_class = class EntityType extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "entityType", _descriptor2, this);
    _initializerDefineProperty(this, "taxId", _descriptor3, this);
    _initializerDefineProperty(this, "confirmationTaxId", _descriptor4, this);
    _initializerDefineProperty(this, "showValidation", _descriptor5, this);
    this.setDefaultEntityType();
  }
  setDefaultEntityType() {
    const isTypeInList = this.args.entityType && this.businessTypeOptions.some(option => option.value === this.args.entityType);
    if (isTypeInList) {
      this.entityType = this.args.entityType;
    }
  }
  get validationTaxIdFields() {
    if (!this.doesEinHave9Digits) {
      return {
        isInvalid: true,
        message: this.intl.t('sfs.signup.agreement.taxId.validationEinRequired')
      };
    } else if (!this.isEinValid) {
      return {
        isInvalid: true,
        message: this.intl.t('sfs.signup.agreement.taxId.validationInvalidEin')
      };
    } else {
      return {
        isInvalid: false
      };
    }
  }
  get validationConfirmationTaxIdFields() {
    if (!this.isEinMatching) {
      return {
        isInvalid: true,
        message: this.intl.t('sfs.signup.agreement.taxId.validationConfirmationEinRequired')
      };
    } else {
      return {
        isInvalid: false
      };
    }
  }
  get validationEntityTypeField() {
    if (!this.entityType) {
      return {
        isInvalid: true,
        message: this.intl.t('sfs.signup.entityType.validationEntityTypeRequired')
      };
    } else {
      return {
        isInvalid: false
      };
    }
  }
  isValid() {
    return !this.validationTaxIdFields.isInvalid && !this.validationConfirmationTaxIdFields.isInvalid && !this.validationEntityTypeField.isInvalid;
  }
  get doesEinHave9Digits() {
    // TODO: only some prefixes are valid, should we check? https://www.irs.gov/businesses/small-businesses-self-employed/how-eins-are-assigned-and-valid-ein-prefixes
    return !this.taxId && this.args.taxIdSerialNumber || this.taxId?.trim().replace(/[•-]/g, '').match(/^\d{9}$/);
  }
  get isEinMatching() {
    return !this.taxId && this.args.taxIdSerialNumber || this.taxId === this.confirmationTaxId;
  }
  get businessTypeOptions() {
    const entityTypesToExclude = this.args.entityTypesToExclude ?? [];
    return Object.keys(NonIndividualLegalEntitiesBusinessEntityType).map(typeLabel => {
      return {
        value: LegalEntitiesBusinessEntityType[
        // We know typeLabel is actually this type since it comes from
        // Object.keys of the enum above
        typeLabel],
        // eslint-disable-next-line square/no-translation-key-interpolation
        label: this.intl.t(`banking.enums.entityType.${typeLabel}`)
      };
    }).filter(businessEntityType => !entityTypesToExclude.includes(businessEntityType.value));
  }
  get isEinValid() {
    return !this.taxId && this.args.taxIdSerialNumber || this.taxId && !DUMMY_TINS.has(this.taxId);
  }
  updateEntityType(event) {
    const entityType = Number(event.detail.value);
    this.entityType = entityType;
    this.args.onEntityTypeChange(this.entityType);
  }
  submit(event) {
    event.preventDefault();
    if (!this.isValid() || !this.entityType) {
      this.showValidation = true;
      return;
    }
    const data = {
      entityType: this.entityType,
      taxId: this.taxId
    };
    this.args.onSubmit(data);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "entityType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "taxId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "confirmationTaxId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showValidation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateEntityType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateEntityType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _class);
export { EntityType as default };